import { Component, OnInit } from '@angular/core';

/**
 * @ignore
 */
@Component({
  selector: 'uex-drawer-subtitle',
  templateUrl: './subtitle.component.html'
})
export class DrawerSubtitleComponent implements OnInit {
  constructor() { }

  ngOnInit() { }
}

/**
 * @ignore
 */
@Component({
  selector: '[uex-drawer-subtitle]',
  template: '<ng-content></ng-content>',
  host: {
    class: 'uex-drawer-subtitle modal-subtitle'
  }
})
export class DrawerHeadingSubtitleComponent implements OnInit {
  constructor() { }

  ngOnInit() { }
}
